export const fromOpts = (opt) => opt.map((opt) => ({name: opt.label, id: opt.value}))
export const toOpts = (data) => data.map((item) => ({label: item.name, value: `${item.id}`}))
export const withNull = (lst) => [...(lst || []), {name: '未入力', id: 'null'}]
export const withNullOpt = (lst) => [...(lst || []), {label: '未入力', value: 'null'}]
export const idToStr = (item) => ({...item, id: `${item.id}`})
